/*
 * Cadeau automatique au seuil (reglages "Produit cadeau auto" + "Seuil cadeau offert").
 *
 * Ajoute automatiquement le produit cadeau au panier quand le total atteint le
 * seuil, et le retire si le panier repasse sous le seuil. La gratuite est
 * assuree par la reduction automatique Shopify "OFFERT" (Achetez X, obtenez Y).
 *
 * - N'ajoute rien si le produit cadeau est deja dans le panier (ajout manuel
 *   via le slider cadeaux ou la fiche produit).
 * - Si le client retire lui-meme le cadeau ajoute automatiquement, il n'est pas
 *   re-ajoute tant que le panier ne repasse pas sous le seuil (memoire de session).
 * - Seules les lignes taguees _auto_gift sont retirees automatiquement.
 */
(function () {
  'use strict';

  var script = document.currentScript || document.querySelector('script[src*="cart-auto-gift"]');
  if (!script) return;
  var VARIANT_ID = parseInt(script.getAttribute('data-gift-variant') || '', 10);
  var THRESHOLD = parseInt(script.getAttribute('data-gift-threshold') || '', 10);
  if (!VARIANT_ID || !THRESHOLD || script.getAttribute('data-gift-available') !== 'true') return;

  var ADDED_KEY = 'bachca_auto_gift_added';
  var busy = false;
  var timer = null;

  function flagAdded(on) {
    try {
      if (on) sessionStorage.setItem(ADDED_KEY, '1');
      else sessionStorage.removeItem(ADDED_KEY);
    } catch (e) { /* navigation privee */ }
  }

  function wasAdded() {
    try { return sessionStorage.getItem(ADDED_KEY) === '1'; } catch (e) { return false; }
  }

  function drawerSections() {
    return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'].filter(function (id) {
      return document.getElementById(id);
    });
  }

  function renderSections(state) {
    if (!state || !state.sections) return;
    Object.keys(state.sections).forEach(function (id) {
      var host = document.getElementById(id);
      if (!host || !state.sections[id]) return;
      var parsed = new DOMParser().parseFromString(state.sections[id], 'text/html').querySelector('.shopify-section');
      if (parsed) host.innerHTML = parsed.innerHTML;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
  }

  function addGift() {
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: VARIANT_ID, quantity: 1, properties: { _auto_gift: 'true' } }],
        sections: drawerSections(),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state && state.status && state.status !== 200) return;
        flagAdded(true);
        renderSections(state);
      });
  }

  function removeGifts(lines) {
    var updates = {};
    lines.forEach(function (line) { updates[line.key] = 0; });
    return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: drawerSections(), sections_url: window.location.pathname })
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        flagAdded(false);
        renderSections(state);
      });
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var giftLines = cart.items.filter(function (item) { return item.variant_id === VARIANT_ID; });
        var autoLines = giftLines.filter(function (item) { return item.properties && item.properties._auto_gift; });
        var autoAmount = autoLines.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
        var baseTotal = cart.total_price - autoAmount;

        if (baseTotal >= THRESHOLD) {
          if (giftLines.length === 0 && !wasAdded()) return addGift();
        } else if (autoLines.length > 0) {
          return removeGifts(autoLines);
        } else {
          flagAdded(false);
        }
      })
      .then(function () { busy = false; })
      .catch(function (error) {
        busy = false;
        console.error('cart-auto-gift:', error);
      });
  }

  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(check, 250);
  }

  // Toute requete panier (tiroir, page panier, quick add, upsell...) declenche
  // une verification une fois la reponse recue.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var result = originalFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      result.then(scheduleCheck, function () {});
    }
    return result;
  };

  document.addEventListener('cartdrawer:opened', scheduleCheck);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCheck);
  } else {
    scheduleCheck();
  }
})();
